require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    d: "M21 3C11.602 3 4 10.602 4 20s7.602 17 17 17 17-7.602 17-17S30.398 3 21 3zm0 30c-7.2 0-13-5.8-13-13S13.8 7 21 7s13 5.8 13 13-5.8 13-13 13zm0 0"
  }), _react["default"].createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "6",
    d: "M31.2 31.2l13.3 13.3"
  }));
};

exports["default"] = _default;